// @owners { team: patients }
import { Button, Illustration } from '@alto/design-system';
import { CommsVerificationCard } from '@alto/features';
import * as React from 'react';
import alertIssue from '~shared/assets/images/alert_issue.png';
import { getCompanyName } from '~shared/config/getCompanyName';
import { IMG_ALT_TEXTS } from '~shared/constants';
import { useNavigateAfterVerification } from '../hooks/useNavigateAfterVerification';

type Props = {
  readonly authorized: boolean;
};

export const CommsVerificationInvalidChannel = ({ authorized }: Props) => {
  const navigateToNextRoute = useNavigateAfterVerification(authorized);

  return (
    <CommsVerificationCard
      headerIcon={
        <Illustration
          size="lg"
          source={alertIssue}
          accessibilityLabel={IMG_ALT_TEXTS.alertIssue}
        />
      }
      title="Something went wrong"
      text="We are not able to verify the communication channel. Please try again or contact support."
      centerText
    >
      <Button
        onPress={navigateToNextRoute}
        label={`Continue to ${getCompanyName()}`}
        accessibilityLabel={`Continue to ${getCompanyName()}`}
        width="full"
      />
    </CommsVerificationCard>
  );
};
